// ItemDisplayer.tsx
import React, { useState, useEffect } from 'react';
import Table from '../../../../../Items/components/Table/Table';
import TableSearchBar from '../../../../../../../../../../components/common/Table/TableSearchBar';
import { getItemsByMenuCategoryId, getAllItemsByLocalId } from '../../../../../../../../../../crud/menu_api/items';
import { Item } from '../../../../../../types';
import LoadingSpinner from '../../../../../../../../../../components/common/LoadingSpinner';
import './ItemDisplayer.scss';
import { MenuCategoryNode } from '../../../../../../types/menu.types';

interface ItemDisplayerProps {
  selectedCategory: any;
  setSelectedCategory: any;
  updateCategoryItems?: (updatedCategory: MenuCategoryNode) => void;
}

const ItemDisplayer: React.FC<ItemDisplayerProps> = ({ selectedCategory, setSelectedCategory, updateCategoryItems }) => {
  const [items, setItems] = useState<Item[]>([]);
  const [originalItems, setOriginalItems] = useState<Item[]>([]);
  const [filteredItems, setFilteredItems] = useState<Item[]>([]);
  const [allItems, setAllItems] = useState<Item[]>([]); // NEW: store all items from the local
  const [loading, setLoading] = useState(false);

  // Fetch all items from the local for duplicate name validation
  useEffect(() => {
    const user = localStorage.getItem('user');
    const localId = user ? JSON.parse(user).local_id : 0;
    
    getAllItemsByLocalId(localId)
      .then((response) => {
        if (response?.data) {
          setAllItems(response.data);
        }
      })
      .catch((error) => {
        console.error('Error fetching all items: ', error);
      });
  }, []); // Run only once on mount

  useEffect(() => {
    setLoading(true);
    getItemsByMenuCategoryId(selectedCategory?.id)
      .then((response) => {
        if (response) {
          const data = response.data;
          setItems(data);
          setFilteredItems(data);
          setOriginalItems(data);
        }
      })
      .catch((error) => {
        console.error('Error fetching items: ', error);
      })
      .finally(() => setLoading(false));
  }, [selectedCategory]);

  if (loading) {
    return <LoadingSpinner text="Cargando items..." transparent={true} />;
  }

  return (
    <div className='item-displayer-main-container'>
      <div className="actions-items-display-container">
        {originalItems.length > 0 && 
        <TableSearchBar
          data={items}
          updateFilteredData={setFilteredItems}
          searchFields={['item_name', 'label']}
          placeholder="Buscar items..."
        />
      }
      </div>
      <Table
        items={filteredItems}
        setData={setItems}
        originalItems={originalItems}
        categoryId={selectedCategory?.id ? String(selectedCategory.id) : undefined}
        setOriginalItems={setOriginalItems}
        allItems={allItems}
        updateCategoryItems={updateCategoryItems}
        onGoBack={() => setSelectedCategory(null)}
      />
    </div>
  );
};

export default ItemDisplayer;
